export default {
    init() {
        this.initDateTimeInputs();
        this.toggleEndDateTime();
        this.toggleRepeatRow();
        this.auctionTypeCheckboxes();
        this.initAuctionSettingsSelects();
        this.divisionRowClone();
        this.preWinnerSettings();
        this.atTheEndAuctionWinnerSettings();
        this.priceTypeSelects();
        this.formSubmitValidation();
    },
    initDateTimeInputs() {
        var today = new Date(); 
        var newdate = new Date();
        newdate.setDate(today.getDate() + 7);

        

        $('.start-date').daterangepicker({
            locale: {
                format: 'YYYY-MM-DD'
            },
            
            singleDatePicker: true,
            autoApply: true,
        }, function(start, end, label) {
            console.log('Date selected: ' + start.format('YYYY-MM-DD'));
        });

        $('.end-date').daterangepicker({
            locale: {
                format: 'YYYY-MM-DD'
            },
            singleDatePicker: true,
            autoApply: true,
        }, function(start, end, label) {
            console.log('Date selected: ' + start.format('YYYY-MM-DD'));
        });

        $('.start-time, .end-time').daterangepicker({
            timePicker: true,
            timePickerIncrement: 5,
            singleDatePicker:true,
            timePicker24Hour: true,
            locale: {
                format: 'HH:mm'
            },
        })
            .on('show.daterangepicker', function (ev, picker) {
            picker.container.find(".calendar-table").hide();
        });
    },
    toggleEndDateTime() {
        let endInputs = $('.end-input');

        if($('.without-end').is(':checked')){
            endInputs.prop('disabled', true);
        } else {
            endInputs.prop('disabled', false);
        }

        $('.without-end').on('change', function () {
            if ($(this).is(':checked')) {
                endInputs.prop('disabled', true);
            } else {
                endInputs.prop('disabled', false);
            }
        });
    },
    toggleRepeatRow() {
        let repeatRow = $('.date-and-time-repeat-wrap')

        $('input.repeat').on('change', function () {
            repeatRow.stop().slideToggle(200);
        });
    },
    auctionTypeCheckboxes() {
        let closedType = $('.auction-type-checkbox-input.closed');
        let openType = $('.auction-type-checkbox-input.open');
        let buynowType = $('.auction-type-checkbox-input.buy-now');

        let openSettings = $('.auction_settings_open');
        let buynowSettings = $('.auction_settings_buy_now');
        let openClosedSettings = $('.auction_settings_start_minimal');
        let winnerRulesSettings = $('.winner-settings-block');

        openSettings.hide();
        buynowSettings.hide();
        openClosedSettings.hide();

        if(openType.is(':checked')) $('.start-price-label').show(); else $('.start-price-label').hide();
        if(closedType.is(':checked')) $('.minimal-price-label').show(); else $('.minimal-price-label').hide();
        if(!openType.is(':checked') && !closedType.is(':checked') && buynowType.is(':checked')){
            winnerRulesSettings.hide();
        } else {
            winnerRulesSettings.show();
        }

        $('.auction-type-checkbox-input').each(function(i, obj) {
            let thisInput = $(this);
            if(thisInput.is(':checked') && thisInput.hasClass('open')){
                closedType.prop('checked', false);
                openSettings.show();
                openClosedSettings.show();
            }
            else if(thisInput.is(':checked') && thisInput.hasClass('closed')){
                openType.prop('checked', false);
                openClosedSettings.show();
            }
            else if(thisInput.is(':checked') && thisInput.hasClass('buy-now')){
                buynowSettings.show();
            }
        });

        $('.auction-type-checkbox-input').on('change', function () {
            let thisInput = $(this);
            if(thisInput.hasClass('open')){
                closedType.prop('checked', false);
                if(thisInput.is(':checked')) {
                    openSettings.show();
                    openClosedSettings.show();
                } else {
                    openSettings.hide();
                    openClosedSettings.hide();
                }
            }
            else if(thisInput.hasClass('closed')){
                openType.prop('checked', false);
                openSettings.hide();
                if(thisInput.is(':checked')) openClosedSettings.show(); else openClosedSettings.hide();
            }
            else if(thisInput.hasClass('buy-now')){
                if(thisInput.is(':checked')) buynowSettings.show(); else buynowSettings.hide();
            }
            
            if(!openType.is(':checked') && !closedType.is(':checked') && buynowType.is(':checked')){
                winnerRulesSettings.hide();
            } else {
                winnerRulesSettings.show();
            }
            if(openType.is(':checked')) $('.start-price-label').show(); else $('.start-price-label').hide();
            if(closedType.is(':checked')) $('.minimal-price-label').show(); else $('.minimal-price-label').hide();

        });
    },

    priceTypeSelects(){
        $('#start_minimal_price_type').on('select2:select', function () {
            let start_minimal_price_type = $(this);

            $("#buy_now_price_type option").each(function() {
                $(this).removeAttr('disabled');
            });
            $('#buy_now_price_type option[value="'+start_minimal_price_type.val()+'"]').attr('disabled','disabled');
            if($('#buy_now_price_type option:selected').val() == start_minimal_price_type.val()){
                $("#buy_now_price_type").val($("#buy_now_price_type option:not(:disabled):first").val()).trigger("change");
            };

            $('.add-row-wrap:not(.new-row)').each(function(){
                $(this).remove();
            });
            $('.add-row-wrap.new-row').each(function(id, rowWrap){
                $(rowWrap).find('select.select2').each(function(id2, select2element){
                    $(select2element).find('option').removeAttr('disabled');
                    $(select2element).val(null).trigger('change');
                });
            });
        });
    },

    initAuctionSettingsSelects() {
        let sellerDealerMultiselect = $('.seller-dealer-multiselect');

        sellerDealerMultiselect.on('select2:select', function () {
            let thisSelect = $(this);

            if (thisSelect.val().includes('Select all')) {
                // Select all
                thisSelect.select2('destroy').find('option').prop('selected', 'selected').end().select2();
            }
        });

        sellerDealerMultiselect.on('select2:unselect', function (e) {
            if (e.params.data.text === 'Select all') {
                $(this).val(null).trigger('change');
            }
        });

        $('.tag-search').select2({ // TODO ajax search
            tags: true,
        });
    },


    divisionRowClone() {
        let select2Options = {
            placeholder: 'Select',
            minimumResultsForSearch: -1
        };

        $('.sortable-list').sortable({
            items: '.add-row-wrap:not(.new-row)',
            cursor: 'pointer',
            axis: 'y',
            handle: '.priority-icon',
        });

        $('.sortable-list').each(function(id, rulesList){
            let newRuleSelect2 = $(rulesList).find('.add-row-wrap.new-row select.select2');
            $(rulesList).find('.add-row-wrap:not(.new-row) select.select2').each(function(id2, selectObj){
                $(newRuleSelect2).find(' option[value="'+$(selectObj).val()+'"]').attr('disabled', 'disabled');
            });
        });

        // add-row-wrap
        $('body').on('click', function (e) {
            if ($(e.target).hasClass('add-row') && $(e.target).hasClass('new')) {
                let parent = $(e.target).closest('.add-row-wrap');
                parent.find('.input-wrap').removeClass('error');
                let validation = true;
                let start_minimal_price_type = $('#start_minimal_price_type').val();

                let select2_value = null;
                $(".input-wrap:not(.disabled) select.select2", parent).each(function () {
                    let element = $(this);
                    if (element.val() === "") {
                        validation = false;
                        element.closest('.input-wrap').addClass('error');
                    } else if(element.val() == start_minimal_price_type){
                        let rows = element.closest('.col-2').siblings('.col-2');
                        if(rows.length == 1 && rows.eq(0).find('input').first().val() <= 100 ){
                            validation = false;
                            rows.eq(0).find('.input-wrap').first().addClass('error');
                        } else if (rows.length == 2 && rows.eq(1).find('input').first().val() <= 100 ){
                            validation = false;
                            rows.eq(1).find('.input-wrap').first().addClass('error');
                        }
                    }
                    select2_value = element.val();
                });

                let reject_element = null;
                let approve_element = null;
                $(".input-wrap:not(.disabled) .form-input", parent).each(function () {
                    let element = $(this);
                    if (element.val() === "") {
                        validation = false;
                        element.closest('.input-wrap').addClass('error');
                    }
                    
                    if(element.attr('name') == 'end_winner_rules[reject][]'){
                        reject_element = element;
                    } else if(element.attr('name') == 'end_winner_rules[approve][]'){
                        approve_element = element;
                    }

                    if(reject_element != null && approve_element != null){
                        if(parseFloat(reject_element.val()) > parseFloat(approve_element.val())){
                            reject_element.closest('.input-wrap').addClass('error');
                            approve_element.closest('.input-wrap').addClass('error');
                            validation = false;
                        }
                        reject_element = null;
                        approve_element = null;
                    };
                });

                // if (validation ==  true) {
                //     $('.new-row select').select2('destroy');
                //     parent.find('.input-wrap').removeClass('error');

                //     let clonedRow = parent.clone();
                //     clonedRow.find('.form-input').val('');
                //     clonedRow.find('select').val('');

                //     clonedRow.insertBefore(parent).attr('id', 'new' + getRandomInt(9, 99));
                    
                //     parent.parent().find('.add-row-wrap').eq(1).removeClass('new-row').find('.add-row.new').hide();
                //     parent.parent().find('.add-row-wrap').eq(1).find('.add-row.delete').addClass('show');
                //     let newDeleteBtn = parent.parent().find('.add-row-wrap').eq(1).find('.add-row.delete');
                    
                //     $('.add-row-wrap select').select2(select2Options);


                //     $('.sortable-list').sortable({
                //         items: '.add-row-wrap:not(.new-row)',
                //         cursor: 'pointer',
                //         axis: 'y',
                //     });
                // }
                if (validation ==  true) {
                    $('.add-row-wrap select').select2('destroy');
                    parent.find('.input-wrap').removeClass('error');
                    let clonedRow = parent.clone();
                    parent.find('select').attr('disabled', 'disabled');
                    parent.find('input').attr('disabled', 'disabled');
                    clonedRow.insertBefore(parent).attr('id', 'new' + getRandomInt(9, 9999));
                    parent.parent().find('.add-row-wrap').eq(1).removeClass('new-row').find('.add-row.new').hide();
                    parent.parent().find('.add-row-wrap.new-row .form-input').val('');
                    parent.parent().find('.add-row-wrap').eq(1).find('.add-row.delete').addClass('show');
                    // let newDeleteBtn = parent.parent().find('.add-row-wrap').eq(1).find('.add-row.delete');
                    // deleteRow(newDeleteBtn);
                    $('.add-row-wrap select').select2(select2Options);

                    $('.sortable-list').sortable({
                        items: '.add-row-wrap:not(.new-row)',
                        cursor: 'pointer',
                        axis: 'y',
                        handle: '.priority-icon',
                    });

                    clonedRow.find('select.select2').eq(0).find(' option[value="'+select2_value+'"]').attr('disabled','disabled');
                }
            }
        });

        function deleteRow(btn) {
            btn.on('click', function () {
                console.log('click');
                $(this).closest('.add-row-wrap').remove();
            });
        }

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('add-row') && $(e.target).hasClass('delete')) {
                let deletedRow = $(e.target).parent().parent();
                let deletedSlect2Val = $(deletedRow).find('select.select2').eq(0).val();
                $(deletedRow).parent().find('.add-row-wrap.new-row select.select2 option[value="'+deletedSlect2Val+'"]').removeAttr('disabled');
                $(e.target).parent().parent().remove();
            }
        });
        
        function getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min) + min);
        }
    },

    preWinnerSettings(){
        let block = $('.pre-winner-block');
        if(!$('.pre-winner-switch').is(':checked')){
            block.hide();
        }
        $('.pre-winner-switch').on('change', function(){
            if($(this).is(':checked')){
                block.slideDown(300);
            } else {
                block.slideUp(300);
            }
        });
    },

    atTheEndAuctionWinnerSettings(){
        let block = $('.at-the-end-auction-winner-block');
        if(!$('.at-auction-end-winner-switch').is(':checked')){
            block.hide();
        }
        $('.at-auction-end-winner-switch').on('change', function(){
            if($(this).is(':checked')){
                block.slideDown(300);
            } else {
                block.slideUp(300);
            }
        });
    },

    formSubmitValidation(){
        $('#submit-btn').on('click', function(e){
            if($('form')[0].checkValidity()){
                e.preventDefault();
                if($('.auction-type-checkbox-input.buy-now').is(':checked') === false){
                    $('#buy_now_price_type').val(null).trigger('change');
                };
                if($('.auction-type-checkbox-input.buy-now').is(':checked') === true && $('.auction-type-checkbox-input.open').is(':checked') === false && $('.auction-type-checkbox-input.closed').is(':checked') === false){
                    $('#start_minimal_price_type').val(null).trigger('change');
                };
                if($('.auction-type-checkbox-input.closed').is(':checked') === true){
                    $('#bid_step').val(1);
                };
                $(".sortable-list .add-row-wrap.new-row select.select2").each(function (id, selectObj) {
                    $(selectObj).val(null).trigger('change');
                });
                $(".sortable-list .add-row-wrap.new-row input").each(function (id, inputObj) {
                    $(inputObj).val(null);
                });
                $('.add-row-wrap:not(.new-row) select.select2').removeAttr('disabled');
                $('.add-row-wrap:not(.new-row) input').removeAttr('disabled');
                if($('.at-auction-end-winner-switch').is(':checked') && $('.at-the-end-auction-winner-block .add-row-wrap:not(.new-row)').length < 1){
                    $('.at-auction-end-winner-switch').attr('checked', false);
                }
                if($('.pre-winner-switch').is(':checked') && $('.pre-winner-block .add-row-wrap:not(.new-row)').length < 1){
                    $('.pre-winner-switch').attr('checked', false);
                }
                $('form').trigger('submit');
            }
        });
    }
}